webpackJsonp([243485111170538],{

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/icon-matriculacion.251ee594.svg";

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-principal-matriculacion.6015be6c.jpg";

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: #202122;\n  & .btn-impuestos {\n    font-weight: 500;\n    font-style: normal;\n    letter-spacing: 1px;\n    padding: 13px 20px;\n    color: #202122;\n    font-size: 20px;\n    margin-top: 0;\n    background: #999a9f;\n    background: linear-gradient(\n      135deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#999a9f', endColorstr='#cbcacb',GradientType=1 );\n    display: inline-block;\n  }\n"], ["\n  background: #202122;\n  & .btn-impuestos {\n    font-weight: 500;\n    font-style: normal;\n    letter-spacing: 1px;\n    padding: 13px 20px;\n    color: #202122;\n    font-size: 20px;\n    margin-top: 0;\n    background: #999a9f;\n    background: linear-gradient(\n      135deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#999a9f', endColorstr='#cbcacb',GradientType=1 );\n    display: inline-block;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 70%;\n  margin: 10px auto 20px auto;\n  text-align: center;\n\n  th {\n    text-align: center;\n    padding: 10px;\n  }\n\n  & .cabecera {\n    background-color: #0f6aac;\n    color: ", ";\n  }\n\n  ", ";\n"], ["\n  width: 70%;\n  margin: 10px auto 20px auto;\n  text-align: center;\n\n  th {\n    text-align: center;\n    padding: 10px;\n  }\n\n  & .cabecera {\n    background-color: #0f6aac;\n    color: ", ";\n  }\n\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    font-size: 12px;\n  "], ["\n    width: 100%;\n    font-size: 12px;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 10px;\n  div {\n    text-align: center;\n    display: block;\n  }\n  p {\n    font-size: 20px !important;\n  }\n  .pay-here {\n    width: 100%;\n    ", ";\n  }\n  a {\n    display: inline-block;\n  }\n"], ["\n  padding-bottom: 10px;\n  div {\n    text-align: center;\n    display: block;\n  }\n  p {\n    font-size: 20px !important;\n  }\n  .pay-here {\n    width: 100%;\n    ", ";\n  }\n  a {\n    display: inline-block;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n      width: 100%;\n  "], ["\n      width: 100%;\n  "]);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _template = __webpack_require__(79);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _styledComponents = __webpack_require__(31);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(55);
	
	var _media = __webpack_require__(35);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _imgPrincipalMatriculacion = __webpack_require__(565);
	
	var _imgPrincipalMatriculacion2 = _interopRequireDefault(_imgPrincipalMatriculacion);
	
	var _iconMatriculacion = __webpack_require__(562);
	
	var _iconMatriculacion2 = _interopRequireDefault(_iconMatriculacion);
	
	var _ModalCondition = __webpack_require__(78);
	
	var _ModalCondition2 = _interopRequireDefault(_ModalCondition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var TableInfo = _styledComponents2.default.table(_templateObject2, _theme.theme.white, _media2.default.sm(_templateObject3));
	
	var Buttons = _styledComponents2.default.div(_templateObject4, _media2.default.xs(_templateObject5));
	
	var title = "Paga tus impuestos en línea.";
	var Matriculacion = function Matriculacion() {
	  var _useState = (0, _react.useState)(false),
	      isOpen = _useState[0],
	      setIsOpen = _useState[1];
	
	  function toggleModal() {
	    setIsOpen(!isOpen);
	  }
	
	  return _react2.default.createElement(
	    _template2.default,
	    { banner: _imgPrincipalMatriculacion2.default, title: title, icon: _iconMatriculacion2.default, active: "matriculacion" },
	    function (_ref) {
	      var handleModalShow = _ref.handleModalShow;
	      return _react2.default.createElement(
	        Content,
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { "class": "col-md-12" },
	          "\xA0"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-lg-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "text-center" },
	            _react2.default.createElement(
	              "a",
	              {
	                id: "CORPIMP_MATRI_CONOZCA",
	                className: "btn-impuestos",
	                onClick: toggleModal
	              },
	              "Conozca m\xE1s sobre la clave temporal"
	            ),
	            _react2.default.createElement(_ModalCondition2.default, {
	              onAfterOpen: false,
	              isOpen: isOpen,
	              onRequestClose: toggleModal,
	              ariaHideApp: false,
	              contentLabel: "ModalMunicipio"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _theme.Container,
	          { className: "title" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Calendario de Pago"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _theme.Container,
	          { className: "content" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12" },
	            _react2.default.createElement(
	              TableInfo,
	              null,
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { className: "cabecera" },
	                  _react2.default.createElement("td", null),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Obligatorio"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Opcional"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "ENERO"
	                  ),
	                  _react2.default.createElement("td", null),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "1"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "FEBRERO"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "1"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "2"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "MARZO"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "2"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "3"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "ABRIL"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "3"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "4"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "MAYO"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "4"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "5"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "JUNIO"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "5"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "6"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "JULIO"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "6"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "7"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "AGOSTO"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "7"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "8"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "SEPTIEMBRE"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "8"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "9"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "OCTUBRE"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "9"
	                  ),
	                  _react2.default.createElement("td", null)
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "NOVIEMBRE"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "0"
	                  ),
	                  _react2.default.createElement("td", null)
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "DICIEMBRE"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Todos"
	                  ),
	                  _react2.default.createElement("td", null)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Buttons,
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 col-sm-12" },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Pague la matr\xEDcula vehicular"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://www.optar.com.ec/Optar.BPagos.Sri/PagoSriVehiculosAS.aspx",
	                      target: "_blank",
	                      className: "btn-impuestos",
	                      id: "CORPIMP_MATRI_MVPAY"
	                    },
	                    "Pague Aqu\xED"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Buttons,
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 col-sm-12" },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Consulte valores a pagar::"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "http://www.amt.gob.ec/index.php/valores-a-pagar.html",
	                      target: "_blank",
	                      className: "btn-impuestos",
	                      id: "CORPIMP_MATRI_VHPAY"
	                    },
	                    "Aqu\xED"
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  );
	};
	
	exports.default = Matriculacion;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-matriculacion-js-01b0f59ada8493a34880.js